import apiClient from './apiClient';
import { Interview, InterviewCreate, InterviewUpdate } from '../types';

const apiBaseURL = '/interviews/';
const interviewPlansBaseURL = '/interview-plans/domains';

const interviewService = {
  /**
   * Get all interviews (requires domain_id or cadrage_id filter)
   */
  async getInterviews(
    domainId?: string,
    cadrageId?: string,
    options?: { skip?: number; limit?: number }
  ): Promise<Interview[]> {
    const params: Record<string, string | number> = {};
    if (domainId) params.domain_id = domainId;
    if (cadrageId) params.cadrage_id = cadrageId;
    if (options?.skip !== undefined) params.skip = options.skip;
    if (options?.limit !== undefined) params.limit = options.limit;
    
    const response = await apiClient.get<Interview[]>(apiBaseURL, { params });
    return response.data;
  },

  /**
   * Get a specific interview by ID
   */
  async getInterview(interviewId: string): Promise<Interview> {
    const response = await apiClient.get<Interview>(`${apiBaseURL}${interviewId}`);
    return response.data;
  },

  /**
   * Create a new interview
   */
  async createInterview(interviewData: InterviewCreate): Promise<Interview> {
    const response = await apiClient.post<Interview>(apiBaseURL, interviewData);
    return response.data;
  },

  /**
   * Update an existing interview
   */
  async updateInterview(interviewId: string, interviewData: InterviewUpdate): Promise<Interview> {
    const response = await apiClient.put<Interview>(`${apiBaseURL}${interviewId}`, interviewData);
    return response.data;
  },

  /**
   * Delete an interview
   */
  async deleteInterview(interviewId: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}${interviewId}`);
  },

  /**
   * Get interview plans for a domain.
   */
  async getDomainInterviewPlans(domainId: string): Promise<any[]> {
    const response = await apiClient.get<any[]>(`${interviewPlansBaseURL}/${domainId}`);
    return response.data;
  },

  /**
   * Create a new interview linked to a domain.
   */
  async createDomainInterview(
    domainId: string,
    payload: { template_id: string; name?: string | null }
  ): Promise<Interview> {
    return this.createInterview({ ...payload, domain_id: domainId });
  },
};

export default interviewService;

